import { userHasRight } from "../../../framework";
import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import K_Toggle from "../templates/K_Toggle";
import { ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface ToggleOptions extends ComponentOptions {
    toolTip?: string;
    labelTrue?: string;
    labelFalse?: string;
    bsc?: string;
    className?: string;
    requiredRight?: string;
}

export class Toggle extends TemplateComponent {

    options: ToggleOptions & RightLockable;

    constructor(options: ToggleOptions) {
        super(K_Toggle, options);
    }

    preRender() {
        const options = this.options;

        this.options.toolTip = ll(options.toolTip);

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);
        }
    }

    create() {
        var checkbox = $(`#${this.options.id}`);
        var bindValue = this.options.bindValue;

        checkbox.tie("change", function (e) {
            var observable = checkbox.data("bindData");
            var checked = checkbox.prop("checked");

            if (!checked && observable) {
                observable.set(bindValue, "false");
                observable.set(bindValue, false);
            }
        });

        if (this.options.toolTip) {
            toolTip({
                selector: $(`#${this.id}_Wrapper`),
                alignTo: "target",
                alignX: "center",
                offsetY: 5
            });
        }
    }

}
